export function setCookie(name, value, opts = {}) {
  if (opts.days) {
    opts['max-age'] = opts.days * 60 * 60 * 24;
    delete opts.days;
  }
  opts = Object.entries(opts).reduce((str, [k, v]) => `${str}; ${k}=${v}`, '');
  document.cookie = name + '=' + encodeURIComponent(value) + opts;
}
export function getCookie(name) {
  let c = document.cookie.match(`(?:(?:^|.*; *)${name} *= *([^;]*).*$)|^.*$`)[1];
  if (c) return decodeURIComponent(c);
  else return null;
}
export function deleteCookie(name, opts) {
  setCookie(name, '', { 'max-age': -1, ...opts });
}
